import { createBrowserRouter, Outlet, ScrollRestoration } from 'react-router';

import { Error } from '@/ui/pages/error/Error';

import { protectedLoader } from './loaders/protected-loader';
import { appRoutes } from './routes/app/appRoutes';
import { externalRoutes } from './routes/external/externalRoutes';
import { rootRoutes } from './routes/root/rootRoutes';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <Error />,
    children: [
      // /*
      ...rootRoutes,
      {
        path: 'app',
        loader: protectedLoader, // /app requires authentication
        children: [
          // /app/*
          ...appRoutes,
        ],
      },
      {
        path: 'external',
        children: [
          // /external/*
          ...externalRoutes,
        ],
      },
    ],
  },
]);

export function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
